import type { Translations } from './en'

const sv: Translations = {
  common: {
    loading: 'Laddar...',
    on: 'På',
    off: 'Av',
    error: 'Något gick fel',
    retry: 'Försök igen',
    cancel: 'Avbryt',
    done: 'Klar',
    today: 'Idag',
    yesterday: 'Igår',
    noResults: 'Inga resultat',
    copied: 'Kopierat',
    stampCount: '{{current}} / {{total}} stämplar',
    activity: {
      type: {
        stamps_added: 'Stämpel intjänad',
        stamp_correction: 'Stämpeljustering',
        reward_unlocked: 'Belöning upplåst',
        reward_redeemed: 'Belöning inlöst',
        reward_restored: 'Belöningsjustering',
        referral_bonus: 'Värvningsbonus',
        reward_expired: 'Belöning utgången',
        new_member_joined: 'Ny medlem anslöt',
        birthday_reward_unlocked: 'Födelsedagsbelöning upplåst',
      },
      actor: {
        manager: 'Chef',
        admin: 'Admin',
        cashier: 'Kassör',
      },
      detail: {
        spendBased:'{{amount}} SEK per stämpel',
        perMeal: 'Per måltid',
        referralBonus: 'Värvningsbonus',
        byActor: 'Av {{actor}}',
        byActorWithItem: '{{item}} · Av {{actor}}',
        targetReduction: 'Stämpelmål sänkt · {{targetBefore}} → {{targetAfter}} per kort',
      },
      stampSingle: 'stämpel',
      stamps: 'stämplar',
      rewardSingle: 'belöning',
      rewards: 'belöningar',
    },
    adjustmentReasons: {
      customer_complaint: 'Kundklagomål',
      system_error: 'Systemfel',
      cashier_mistake: 'Kassörsmisstag',
      promotion: 'Kampanj / goodwill',
      other: 'Övrigt',
    },
  },
  error: {
    title: 'Något gick fel',
    subtitle: 'Vi kunde inte slutföra din förfrågan.\nFörsök igen.',
    tryAgain: 'Försök igen',
    footer: 'Om detta fortsätter att hända, försök igen senare.',
    imageAccessibilityLabel: 'Felikon',
  },
  placeholder: {
    cashierReady: 'Kassaappen är redo.',
    adminReady: 'Adminpanelen är redo.',
  },
  adminDashboard: {
    homeTitle: 'Hem',
    homeSubtitle: 'Översikt över aktivitet i lojalitetsprogrammet.',
    home: {
      chart: {
        title: 'Lojalitetstrender',
        subtitle: 'Följ viktiga lojalitetsmått över tid.',
      },
      totalMembers: {
        label: 'Totalt antal medlemmar',
        allTime: 'Totalt',
      },
      stats: {
        stampsAdded: 'Stämplar tillagda',
        rewardsRedeemed: 'Belöningar inlösta',
        rewardsUnlocked: 'Belöningar upplåsta',
        newMembers: 'Nya medlemmar',
        vsPrevDays: 'vs föreg. {{count}} dagar',
      },
    },
    membersTitle: 'Medlemmar',
    membersSubtitle: 'Sök efter en medlem och visa eller justera deras stämplar och belöningar.',
    recentActivityTitle: 'Senaste aktivitet',
    recentActivitySubtitle: 'Granska lojalitetsaktivitet för medlemmar och personal.',
    auditLogTitle: 'Granskningslogg',
    auditLogSubtitle: 'Följ admin- och systemändringar.',
    loyaltyTitle: 'Lojalitet',
    loyaltySubtitle: 'Konfigurera ditt lojalitetsprogram och belöningar.',
    birthdayRewardTitle: 'Födelsedagsbelöning',
    birthdayRewardSubtitle: 'Konfigurera födelsedagsbelöningsprogrammet.',
    operationsTitle: 'Drift',
    operationsSubtitle: 'Hantera kassörer, enheter och filialer.',
    settingsTitle: 'Appinställningar',
    settingsSubtitle: 'Konfigurera app- och programalternativ.',
  },
  operations: {
    actions: {
      new: 'Ny',
      addCashier: 'Lägg till kassör',
      registerDevice: 'Registrera enhet',
    },
    cashiers: {
      title: 'Kassörer',
      description: 'Personal- och chefskoder för kassaenheter.',
      columns: {
        cashier: 'Kassör',
        role: 'Roll',
        status: 'Status',
        lastActivity: 'Senaste aktivitet',
      },
      editAccessibilityLabel: 'Redigera kassör {{name}}',
      emptyTitle: 'Inga kassörer än',
      emptyDescription: 'Lägg till kassörer för att ge personal och chefer PIN-åtkomst till kassaenheter.',
      loadError: 'Kunde inte ladda kassörer. Försök igen.',
      noResults: 'Inga kassörer matchar de valda filtren.',
    },
    devices: {
      title: 'Enheter',
      description: 'Registrerade enheter som används av kassörer.',
      columns: {
        device: 'Enhet',
        branch: 'Filial',
        status: 'Status',
        lastActivity: 'Senaste aktivitet',
      },
      editAccessibilityLabel: 'Redigera enhet {{name}}',
      emptyTitle: 'Inga enheter registrerade',
      emptyDescription: 'Registrera enheter så att kassörer kan hantera stämplar och belöningar.',
      loadError: 'Kunde inte ladda enheter. Försök igen.',
      noResults: 'Inga enheter matchar de valda filtren.',
    },
    roles: {
      staff: 'Personal',
      manager: 'Chef',
    },
    statuses: {
      active: 'Aktiv',
      inactive: 'Inaktiv',
      pending: 'Väntande',
    },
    filters: {
      label: 'Filtrera',
      clear: 'Rensa filter',
    },
    pagination: {
      range: 'Visar {{start}}-{{end}} av {{total}}',
      previous: 'Föregående',
      next: 'Nästa',
    },
    addDevice: {
      title: 'Lägg till enhet',
      closeAccessibilityLabel: 'Stäng lägg till enhet',
      deviceNameLabel: 'Enhetsnamn',
      deviceNamePlaceholder: 't.ex. Front Counter Tablet',
      deviceNameRequiredError: 'Ange ett enhetsnamn',
      branchLabel: 'Filial',
      branchPlaceholder: 'Välj filial',
      branchRequiredError: 'Välj en filial',
      submitButton: 'Lägg till enhet',
      submittingButton: 'Lägger till...',
      successTitle: 'Enhet tillagd',
      successDescription: 'Parkoppla den här enheten med kassörappen för att slutföra installationen.',
      pairingCodeLabel: 'Parkopplingskod',
      pairingCodeOneTimeNote: 'Kopiera koden nu — den visas inte igen.',
      pairingCodeExpiresAt: 'Går ut {{time}} idag',
      pairingCodeExpiresAtTomorrow: 'Går ut {{time}} imorgon',
      copyCodeButton: 'Kopiera kod',
      copiedCodeButton: 'Kopierat!',
      copyCodeAccessibilityLabel: 'Kopiera parkopplingskod',
      nameConflictError: 'En enhet med det namnet finns redan i den här filialen.',
      submitError: 'Något gick fel. Försök igen.',
      addAnotherButton: 'Lägg till en till',
    },
    editDevice: {
      title: 'Redigera enhet',
      subtitle: 'Uppdatera enhetens uppgifter och hantera status.',
      closeAccessibilityLabel: 'Stäng redigera enhet',
      statusLabel: 'Status',
      pendingTitle: 'Väntar på parkoppling',
      pendingDescription: 'Den här enheten har inte parkopplats ännu.',
      pairingCodeUnavailablePrefix: 'Parkopplingskod ej tillgänglig. ',
      pairingCodeExpiredPrefix: 'Parkopplingskoden har gått ut. ',
      pairingCodeRegenerateLink: 'Generera en ny.',
      copyCodeAccessibilityLabel: 'Kopiera parkopplingskod',
      regenerateCodeButton: 'Generera ny kod',
      regeneratingCodeButton: 'Genererar...',
      regenerateCodeError: 'Kunde inte generera ny kod. Försök igen.',
      reactivateButton: 'Återaktivera',
      reactivatingButton: 'Återaktiverar...',
      reactivateError: 'Kunde inte återaktivera enheten. Försök igen.',
      makeInactiveButton: 'Inaktivera',
      makingInactiveButton: 'Inaktiverar...',
      statusChangeError: 'Kunde inte uppdatera enhetens status. Försök igen.',
      inactiveNote: 'Inaktiva enheter kan inte hantera stämplar eller belöningar.',
      activeNote: 'Den här enheten är parkopplad och redo att hantera stämplar och belöningar.',
      pairingCodeExpiredDescription: 'Den här enheten har inte parkopplats ännu. Generera en ny kod för att parkoppla enheten.',
      generateNewCodeButton: 'Generera ny kod',
      generatingNewCodeButton: 'Genererar...',
      savedLabel: 'Sparat',
      submitButton: 'Spara ändringar',
      savingButton: 'Sparar...',
      nameConflictError: 'En enhet med det namnet finns redan i den här filialen.',
      reactivateNameConflictError: 'En annan aktiv enhet har redan det här namnet i filialen. Byt namn på den först och återaktivera sedan.',
      reactivateStateConflictError: 'Enhetens status ändrades någon annanstans. Stäng och öppna igen för att se den senaste statusen.',
      submitError: 'Något gick fel. Försök igen.',
    },
    addCashier: {
      title: 'Lägg till kassör',
      closeAccessibilityLabel: 'Stäng lägg till kassör',
      nameLabel: 'Kassörens namn',
      namePlaceholder: 't.ex. Emma Andersson',
      nameRequiredError: 'Ange ett namn',
      emailLabel: 'E-post (valfritt)',
      emailPlaceholder: 't.ex. emma@chillout.com',
      emailInvalidError: 'Ange en giltig e-postadress',
      roleLabel: 'Roll',
      submitButton: 'Skapa kassör',
      submittingButton: 'Skapar...',
      submitError: 'Något gick fel. Försök igen.',
      pinTitle: 'Kassör tillagd',
      pinDescription: 'Dela denna PIN med kassören. De kan använda den direkt och uppdatera den när de vill.',
      pinCopyButton: 'Kopiera PIN',
      pinCopiedButton: 'Kopierad!',
    },
    editCashier: {
      title: 'Redigera kassör',
      subtitle: 'Uppdatera kassörens uppgifter och status.',
      closeAccessibilityLabel: 'Stäng redigera kassör',
      nameLabel: 'Fullständigt namn',
      namePlaceholder: 't.ex. Emma Andersson',
      nameRequiredError: 'Ange ett namn',
      emailLabel: 'E-post (valfritt)',
      emailPlaceholder: 't.ex. emma@chillout.com',
      emailInvalidError: 'Ange en giltig e-postadress',
      roleLabel: 'Roll',
      statusLabel: 'Status',
      inactiveNote: 'Inaktiva kassörer kan inte logga in på kassaenheter.',
      makeInactiveButton: 'Inaktivera',
      makingInactiveButton: 'Inaktiverar...',
      deactivateButton: 'Inaktivera',
      deactivatingButton: 'Inaktiverar...',
      deactivateConfirmDescription: 'Den här kassörens PIN-kod slutar fungera omedelbart.',
      deactivateError: 'Något gick fel. Försök igen.',
      reactivateButton: 'Återaktivera',
      reactivatingButton: 'Återaktiverar...',
      reactivatePinTitle: 'Kassör återaktiverad',
      statusChangeError: 'Något gick fel. Försök igen.',
      pinAccessLabel: 'PIN-åtkomst',
      pinAccessDescription: 'Kassörens PIN är dold av säkerhetsskäl. Återställ den bara om kassören inte kan logga in.',
      resetPinButton: 'Återställ PIN',
      submitButton: 'Spara ändringar',
      savingButton: 'Sparar...',
      submitError: 'Något gick fel. Försök igen.',
      resetPinInactiveNote: 'Återställning av PIN är inte tillgänglig för inaktiva kassörer. Aktivera kassören först.',
      resetPinTitle: 'Återställ PIN',
      resetPinDescription: 'Återställ den här kassörens PIN?\nDen nuvarande PIN-koden slutar fungera omedelbart.',
      resetPinBackButton: 'Tillbaka',
      resetPinConfirmButton: 'Återställ PIN',
      resetPinResettingButton: 'Återställer...',
      resetPinError: 'Något gick fel. Försök igen.',
      pinTitle: 'PIN återställd',
      pinDescription: 'Dela denna nya PIN med kassören. Deras tidigare PIN fungerar inte längre.',
      pinCopyButton: 'Kopiera PIN',
      pinCopiedButton: 'Kopierad!',
    },
  },
  members: {
    search: {
      label: 'Sök',
      placeholder: 'Sök med namn, e-post eller medlems-ID',
      helperText: 'Ange ett namn, en e-postadress eller ett medlems-ID.',
      accessibilityLabel: 'Sök medlemmar med namn, e-post eller medlems-ID',
      clearAccessibilityLabel: 'Rensa sökning',
    },
    emptyState: {
      title: 'Sök efter en medlem',
      description: 'Ange ett namn, en e-postadress eller ett medlems-ID ovan för att hitta en medlem och hantera deras lojalitetssaldo.',
    },
    results: {
      heading: 'Sökresultat',
      count_one: '{{count}} medlem hittad',
      count_other: '{{count}} medlemmar hittade',
      noResults: 'Inga medlemmar matchar din sökning.',
    },
    columns: {
      member: 'Medlem',
      email: 'E-post',
      stamps: 'Stämplar',
      rewards: 'Belöningar',
    },
    stampProgress: '{{current}} / {{target}} stämplar',
    rewardCount: '{{count}} belöningar',
    rowAccessibilityLabel: '{{name}}, {{current}} av {{target}} stämplar, {{rewardCount}} belöningar',
    detail: {
      backToResults: 'Tillbaka till resultat',
      memberSince: 'Medlem sedan {{date}}',
      anonymiseButton: 'Anonymisera',
      anonymise: {
        confirmTitle: 'Anonymisera {{name}}?',
        confirmBody: 'Detta tar permanent bort all personlig information för denna medlem. Åtgärden kan inte ångras.',
        confirmWarning: 'Denna åtgärd är permanent och kan inte ångras.',
        emailConfirmLabel: 'Skriv medlemmens e-post för att bekräfta',
        emailConfirmPlaceholder: 'Ange medlemmens e-post',
        emailMismatch: 'E-posten matchar inte',
        confirmButton: 'Anonymisera medlem',
        confirmingButton: 'Anonymiserar...',
        applyError: 'Kunde inte anonymisera medlem. Försök igen.',
      },
      tabs: {
        stamps: 'Stämplar',
        rewards: 'Belöningar',
      },
      stampPreview: {
        title: 'Stämpelförhandsvisning',
        balance: '{{current}} / {{target}}',
        stampFilledAccessibilityLabel: 'Stämpel intjänad',
        stampEmptyAccessibilityLabel: 'Tom stämpelplats',
      },
      availableRewards: {
        title: 'Tillgängliga belöningar',
        expiresAt: 'Går ut {{date}}',
        noExpiry: 'Inget utgångsdatum',
        empty: 'Inga tillgängliga belöningar.',
      },
      recentActivity: {
        title: 'Senaste aktivitet',
        viewAll: 'Visa alla',
        viewAllAccessibilityLabel: 'Visa all medlemsaktivitet',
        empty: 'Ingen aktivitet ännu.',
        activityType: {
          stamps_added: 'Stämplar tillagda',
          stamp_correction: 'Stämpelkorrigering',
          reward_unlocked: 'Belöning upplåst',
          reward_redeemed: 'Belöning inlöst',
          reward_restored: 'Belöning återställd',
          referral_bonus: 'Värvningsbonus',
          reward_expired: 'Belöning utgången',
        },
      },
      loadError: 'Kunde inte ladda medlemsuppgifter. Försök igen.',
      stampAdjustment: {
        numberOfStamps: 'Antal stämplar',
        stampCountSingle: '1 stämpel',
        stampCount: '{{count}} stämplar',
        willAdd: 'Detta lägger till {{count}} stämpel',
        willAddPlural: 'Detta lägger till {{count}} stämplar',
        willRemove: 'Detta tar bort {{count}} stämpel',
        willRemovePlural: 'Detta tar bort {{count}} stämplar',
        decrementAccessibilityLabel: 'Minska antal stämplar',
        incrementAccessibilityLabel: 'Öka antal stämplar',
        countAccessibilityLabel: '{{count}} stämplar valda',
        reason: 'Anledning',
        reasonPlaceholder: 'Välj en anledning',
        reasonRequired: 'Välj en anledning',
        reasonOptions: {
          customer_complaint: 'Kundklagomål',
          system_error: 'Systemfel',
          cashier_mistake: 'Kassörsmisstag',
          promotion: 'Kampanj / goodwill',
          other: 'Övrigt',
        },
        note: 'Anteckning (valfritt)',
        notePlaceholder: 'Lägg till en anteckning om denna justering...',
        applyButton: 'Tillämpa stämpeljustering',
        applyingButton: 'Tillämpar...',
        confirmTitle_add: 'Lägga till {{count}} stämplar?',
        confirmTitle_remove: 'Ta bort {{count}} stämplar?',
        confirmButton_add_one: 'Lägg till {{count}} stämpel',
        confirmButton_add_other: 'Lägg till {{count}} stämplar',
        confirmButton_remove_one: 'Ta bort {{count}} stämpel',
        confirmButton_remove_other: 'Ta bort {{count}} stämplar',
        confirmBody_add: 'Du är på väg att lägga till {{count}} stämplar till denna medlem.',
        confirmBody_remove: 'Du är på väg att ta bort {{count}} stämplar från denna medlem.',
        confirmBefore: 'Innan',
        confirmAfter: 'Efter',
        auditWarning: 'Denna justering kommer att registreras i aktivitets- och granskningsloggarna.',
        applyError: 'Kunde inte tillämpa stämpeljustering. Försök igen.',
      },
      rewardAdjustment: {
        rewardBalance: 'Belöningssaldo',
        adjustQuantity: 'Justera antal',
        rewardCountSingle: '1 belöning',
        rewardCount: '{{count}} belöningar',
        decrementAccessibilityLabel: 'Minska antal belöningar',
        incrementAccessibilityLabel: 'Öka antal belöningar',
        countAccessibilityLabel: '{{count}} belöningar valda',
        reason: 'Anledning',
        reasonPlaceholder: 'Välj en anledning',
        reasonOptions: {
          customer_complaint: 'Kundklagomål',
          system_error: 'Systemfel',
          cashier_mistake: 'Kassörsmisstag',
          promotion: 'Kampanj / goodwill',
          other: 'Övrigt',
        },
        note: 'Anteckning (valfritt)',
        notePlaceholder: 'Lägg till en anteckning om denna justering...',
        applyButton: 'Tillämpa belöningsjustering',
        applyingButton: 'Tillämpar...',
        confirmTitle_add: 'Lägga till {{count}} {{name}} belöningar?',
        confirmTitle_remove: 'Ta bort {{count}} {{name}} belöningar?',
        confirmButton_add_one: 'Lägg till {{count}} belöning',
        confirmButton_add_other: 'Lägg till {{count}} belöningar',
        confirmButton_remove_one: 'Ta bort {{count}} belöning',
        confirmButton_remove_other: 'Ta bort {{count}} belöningar',
        confirmBody_add: 'Du är på väg att lägga till {{count}} {{name}} belöningar till denna medlem.',
        confirmBody_remove: 'Du är på väg att ta bort {{count}} {{name}} belöningar från denna medlem.',
        applyError: 'Kunde inte tillämpa belöningsjustering. Försök igen.',
        selectCardAccessibilityLabel: 'Välj {{name}}',
      },
    },
    searchError: 'Kunde inte söka medlemmar. Försök igen.',
  },
  adminAuth: {
    logoAccessibilityLabel: 'Chill Out',
    signInIconAccessibilityLabel: 'Administratörskonto',
    signInPlaceholder: 'Admininloggning',
    signInSubtitle: 'Hantera lojalitetsinställningar, kassörer och enheter.',
    emailLabel: 'E-post',
    emailPlaceholder: 'Ange din e-post',
    emailRequiredError: 'Ange din e-postadress',
    emailInvalidError: 'Ange en giltig e-postadress',
    passwordLabel: 'Lösenord',
    passwordPlaceholder: 'Ange ditt lösenord',
    passwordRequiredError: 'Ange ditt lösenord',
    passwordTooShortError: 'Använd minst 10 tecken',
    showPasswordAccessibilityLabel: 'Visa lösenord',
    hidePasswordAccessibilityLabel: 'Dölj lösenord',
    forgotPassword: 'Glömt lösenord?',
    signInError: 'Vi kunde inte logga in dig. Kontrollera e-post och lösenord och försök igen.',
    signInButton: 'Logga in',
    signingInButton: 'Loggar in...',
    forgotPasswordIconAccessibilityLabel: 'Återställ lösenord',
    forgotPasswordTitle: 'Glömt lösenord?',
    forgotPasswordSubtitle: 'Ange din admin-e-post så skickar vi en länk för att återställa ditt lösenord.',
    sendResetLinkButton: 'Skicka återställningslänk',
    sendingResetLinkButton: 'Skickar...',
    resetLinkRequestError: 'Vi kunde inte skicka en återställningslänk just nu. Försök igen senare.',
    checkEmailIconAccessibilityLabel: 'Återställningsmejl skickat',
    checkEmailTitle: 'Kontrollera din e-post',
    checkEmailSubtitle: 'Om e-postadressen tillhör ett administratörskonto skickar vi en länk för att återställa lösenordet.',
    checkEmailNoteIconAccessibilityLabel: 'Påminnelse om att skicka e-post igen',
    checkEmailNoteTitle: 'Fick du inget mejl?',
    checkEmailNoteBody: 'Kontrollera skräpposten eller försök skicka länken igen.',
    resendTimerPrefix: 'Du kan skicka länken igen om',
    resendReadyMessage: 'Du kan skicka länken igen nu',
    sendAgainButton: 'Skicka igen',
    sendingAgainButton: 'Skickar...',
    createPasswordIconAccessibilityLabel: 'Nytt lösenord',
    createPasswordTitle: 'Skapa nytt lösenord',
    createPasswordSubtitle: 'Ange och bekräfta ditt nya lösenord för att fortsätta.',
    newPasswordLabel: 'Nytt lösenord',
    newPasswordPlaceholder: 'Ange ditt nya lösenord',
    newPasswordHelperText: 'Använd minst 10 tecken. Längre lösenord är säkrare.',
    confirmPasswordLabel: 'Bekräfta lösenord',
    confirmPasswordPlaceholder: 'Bekräfta ditt nya lösenord',
    confirmPasswordRequiredError: 'Bekräfta ditt lösenord',
    passwordsDoNotMatchError: 'Lösenorden matchar inte',
    updatePasswordButton: 'Uppdatera lösenord',
    updatingPasswordButton: 'Uppdaterar...',
    samePasswordError: 'Ditt nya lösenord måste skilja sig från ditt nuvarande lösenord.',
    updatePasswordError: 'Vi kunde inte uppdatera ditt lösenord. Begär en ny återställningslänk och försök igen.',
    resetLinkErrorIconAccessibilityLabel: 'Ogiltig återställningslänk',
    resetLinkErrorTitle: 'Ogiltig eller utgången länk',
    resetLinkErrorSubtitle: 'Den här länken för att återställa lösenordet kan inte användas. Begär en ny länk för att fortsätta.',
    requestNewLinkButton: 'Begär ny länk',
    backToSignIn: 'Tillbaka till inloggning',
  },
  cashierHeader: {
    logoAccessibilityLabel: 'Chill Out',
    menuButton: 'Enhetsmeny',
    backButton: 'Gå tillbaka',
    changeCashierPinItem: 'Ändra kassörs-PIN',
    unpairItem: 'Koppla bort enhet',
    unpairConfirmTitle: 'Koppla bort den här enheten?',
    unpairConfirmMessage: 'Enheten loggas ut och måste parkopplas igen från adminpanelen innan den kan användas.',
    unpairCancelButton: 'Avbryt',
    unpairConfirmButton: 'Koppla bort',
    unpairErrorTitle: 'Kunde inte koppla bort enheten',
    unpairErrorMessage: 'Kontrollera anslutningen och försök igen.',
  },
  cashierChangePin: {
    currentPinTitle: 'Ange nuvarande PIN',
    currentPinSubtitle: 'Ange din nuvarande kassörs-PIN.',
    currentPinModalAccessibilityLabel: 'Ange nuvarande kassörs-PIN',
    newPinTitle: 'Ange ny PIN',
    newPinSubtitle: 'Välj en ny 4-siffrig PIN.',
    newPinModalAccessibilityLabel: 'Ange ny kassörs-PIN',
    confirmPinTitle: 'Bekräfta ny PIN',
    confirmPinSubtitle: 'Ange den nya PIN-koden igen.',
    confirmPinModalAccessibilityLabel: 'Bekräfta ny kassörs-PIN',
    currentPinInvalidError: 'Nuvarande PIN är fel.',
    newPinInvalidError: 'Ange en 4-siffrig PIN.',
    confirmPinMismatchError: 'PIN-koderna matchar inte. Försök igen.',
    updatePinNetworkError: 'Kunde inte verifiera PIN. Kontrollera anslutningen och försök igen.',
    successTitle: 'PIN uppdaterad',
    successSubtitle: 'Din kassörs-PIN har uppdaterats.',
    successModalAccessibilityLabel: 'Kassörs-PIN uppdaterad',
    successImageAccessibilityLabel: 'Illustration för uppdaterad PIN',
    doneButton: 'Klar',
    closeModalAccessibilityLabel: 'Stäng ändring av kassörs-PIN',
    pinProgressAccessibilityLabel: '{{entered}} av {{total}} PIN-siffror angivna',
  },
  cashierPairing: {
    iconAccessibilityLabel: 'Parkoppla enhet',
    title: 'Parkoppla den här enheten',
    subtitle: 'Skanna parkopplings-QR-koden från adminpanelen eller ange den 6-siffriga parkopplingskoden manuellt.',
    scanQRButton: 'Skanna QR-kod',
    enterCodeButton: 'Ange kod manuellt',
    codeScreenTitle: 'Ange parkopplingskod',
    codeScreenSubtitle: 'Ange den 6-siffriga parkopplingskoden från adminpanelen.',
    scanQRInstead: 'Skanna QR-kod istället',
    scanQRScreenTitle: 'Skanna parkopplings-QR',
    scanQRScreenSubtitle: 'Rikta kameran mot parkopplings-QR-koden från adminpanelen.',
    scanInvalidError: 'Det här är inte en giltig parkopplings-QR-kod.',
    cameraPermissionDescription: 'Kameraåtkomst behövs för att skanna parkopplings-QR-koden.',
    cameraPermissionDeniedDescription: 'Kameraåtkomst är avstängd. Aktivera den i Inställningar för att skanna QR-koder.',
    cameraPermissionButton: 'Tillåt kameraåtkomst',
    cameraSettingsButton: 'Öppna inställningar',
    codeFormatError: 'Ange den 6-siffriga parkopplingskoden från adminpanelen.',
    codeInvalidError: 'Parkopplingskoden hittades inte. Kontrollera koden eller begär en ny från adminpanelen.',
    codeExpiredError: 'Parkopplingskoden har gått ut. Begär en ny kod från adminpanelen.',
    codeNetworkError: 'Kunde inte ansluta. Kontrollera din anslutning och försök igen.',
    codeServerError: 'Kunde inte slutföra parkopplingen. Kontrollera serverloggarna och försök igen.',
    codeProgressAccessibilityLabel: '{{entered}} av {{total}} siffror i parkopplingskoden angivna',
    successImageAccessibilityLabel: 'Enhet parkopplad',
    successTitle: '{{deviceName}} är parkopplad till {{branchName}}.',
    successSubtitle: 'Den här enheten är nu redo att användas.',
    successContinue: 'Fortsätt',
  },
  numpad: {
    deleteButton: 'Radera',
    confirmButton: 'Bekräfta',
    doubleZeroButton: 'Dubbel nolla',
  },
  cashierHome: {
    scannerTitle: 'Skanna member- eller belönings-QR',
    scannerSubtitle: 'Rikta kameran mot kundens QR-kod.',
    scannerTitleAccessibilityLabel: 'Skannersstatus',
    cameraPermissionDescription: 'Kameraåtkomst krävs för att skanna member- och belönings-QR-koder.',
    cameraPermissionDeniedDescription: 'Kameraåtkomst är avstängd. Aktivera den i Inställningar för att skanna QR-koder.',
    cameraPermissionButton: 'Tillåt kameraåtkomst',
    cameraSettingsButton: 'Öppna inställningar',
    tapToResume: 'Tryck för att fortsätta',
    idleAccessibilityLabel: 'Skannern är pausad. Tryck för att fortsätta skanna.',
    cantScanHint: 'Kan du inte skanna QR-koden?',
    manualLookupTitle: 'Manuell sökning',
    manualLookupSubtitle: 'Hitta en medlem genom att ange deras e-post eller medlems-ID.',
    searchPlaceholder: 'Sök med e-post eller medlems-ID',
    searchAccessibilityLabel: 'Sök med e-post eller medlems-ID',
    searchButton: 'Sök',
    memberFound: 'Medlem hittad',
    memberFoundBackdropAccessibilityLabel: 'Stäng medlemskort',
    memberFoundMenuAccessibilityLabel: 'Fler alternativ',
    memberFoundUnknownName: 'Okänd medlem',
    scanInstead: 'Skanna QR istället',
    scanInsteadAccessibilityLabel: 'Byt tillbaka till QR-skannern',
    searchFormatError: 'Ange en giltig e-postadress eller ett medlems-ID (t.ex. CO000000).',
    searchNotFoundError: 'Ingen medlem hittades. Kontrollera e-postadressen eller medlems-ID och försök igen.',
    searchNetworkError: 'Kunde inte ansluta. Kontrollera din anslutning och försök igen.',
    exactMatchOnly: 'Exakt matchning',
    exactMatchDescription: 'Ange hela e-postadressen eller medlems-ID för att skydda kundens integritet.',
    enterManually: 'Ange manuellt',
    enterManuallyAccessibilityLabel: 'Ange medlemsuppgifter manuellt',
    scanErrorTitle: 'QR-skanning misslyckades',
    scanErrorDismiss: 'OK',
    scanInvalidError: 'Den här QR-koden är inte giltig.',
    scanExpiredError: 'Den här QR-koden har gått ut. Be kunden att uppdatera den.',
    scanMemberNotFoundError: 'Ingen medlem hittades för den här QR-koden.',
    scanAlreadyConsumedError: 'Den här belöningen har redan använts.',
    scanNoLongerActiveError: 'Den här inlösningskoden är inte längre aktiv.',
    scanNetworkError: 'Kunde inte verifiera QR-koden. Kontrollera din anslutning och försök igen.',
  },
  nav: {
    home: 'Hem',
    members: 'Medlemmar',
    recentActivity: 'Senaste aktivitet',
    auditLog: 'Granskningslogg',
    loyalty: 'Lojalitet',
    birthdayReward: 'Födelsedagsbelöning',
    operations: 'Drift',
    settings: 'Appinställningar',
    logOut: 'Logga ut',
    openMenu: 'Öppna meny',
    closeMenu: 'Stäng meny',
    version: 'v{{version}}',
    updateAvailable: 'En ny version är tillgänglig.',
    updateMessage: 'Uppdatera för att få de senaste ändringarna.',
    updateRefresh: 'Uppdatera nu',
    updateDismissAccessibilityLabel: 'Stäng uppdateringsnotis',
  },
  rewardRedemption: {
    sheetBackdropAccessibilityLabel: 'Stäng belöningsinlösningskortet',
    rewardFound: 'Belöning hittad',
    unknownMember: 'Okänd medlem',
    qrValid: 'QR-kod giltig · {{countdown}}',
    qrExpired: 'QR-koden har gått ut',
    rewardToRedeem: 'Belöning att lösa in',
    currentCount: 'Just nu',
    afterCount: 'Efter detta',
    rewardWithQuantity: '{{name}} × {{count}}',
    insufficientRewardsWarning: 'QR-koden gäller {{requested}} belöningar men kunden har bara {{available}}.',
    continueButton: 'Fortsätt',
    staffPin: {
      title: 'Kassör-PIN',
      subtitle: 'Ange din PIN-kod för att bekräfta inlösningen.',
      modalAccessibilityLabel: 'Bekräftelse av kassör-PIN',
      closeAccessibilityLabel: 'Avbryt PIN-inmatning',
      codeProgressAccessibilityLabel: '{{entered}} av {{total}} siffror angivna',
      incorrectPin: 'Felaktig PIN. Försök igen.',
      redeemError: 'Kunde inte lösa in belöningen. Försök igen.',
    },
    success: {
      title: 'Belöning inlöst',
      usedSingle: '{{rewardName}} använd för {{fullName}}.',
      used: '{{count}}× {{rewardName}} använda för {{fullName}}.',
      remainingPrefix: '{{firstName}} har nu',
      remainingSuffix: 'tillgängliga {{rewardName}}-belöningar.',
      scanNext: 'Skanna nästa',
      done: 'Klar',
    },
  },
  rewardRestore: {
    title: 'Återställ belöning',
    noRewardItems: 'Inga belöningsartiklar hittades.',
    rewardBalance: {
      title: 'Belöningssaldo',
      count: '×{{count}}',
      pendingDelta: '+{{count}}',
      cardAccessibilityLabel: 'Välj {{name}}, {{count}} tillgängliga',
    },
    stepper: {
      label: 'Belöningar att återställa',
      rewardSingle: '+ 1 belöning',
      rewards: '+ {{count}} belöningar',
      decrementAccessibilityLabel: 'Återställ färre belöningar',
      incrementAccessibilityLabel: 'Återställ fler belöningar',
      countAccessibilityLabel: 'Återställer {{count}} belöningar',
    },
    balancePreview: {
      current: 'Nuvarande:',
      available: '{{count}} tillgängliga',
    },
    reason: {
      label: 'Orsak till återställning',
      placeholder: 'Välj en orsak',
    },
    note: 'Anteckning (valfri)',
    notePlaceholder: 'Lägg till en anteckning om återställningen...',
    disclaimer: 'Den här åtgärden skapar en korrigeringspost. Den ursprungliga aktiviteten förblir oförändrad.',
    restoreButton: 'Återställ belöning',
    managerPin: {
      title: 'Chefs-PIN',
      subtitle: 'Ange chefs-PIN för att återställa belöning.',
      modalAccessibilityLabel: 'Chefs-PIN-auktorisering',
      closeAccessibilityLabel: 'Avbryt PIN-inmatning',
      codeProgressAccessibilityLabel: '{{entered}} av {{total}} siffror angivna',
      incorrectPin: 'Felaktig PIN. Försök igen.',
      restoreError: 'Kunde inte återställa belöning. Försök igen.',
    },
    success: {
      title: 'Belöning återställd',
      rewardSingle: '1 {{name}} återställd för {{fullName}}.',
      rewards: '{{count}} {{name}} återställda för {{fullName}}.',
      newTotalSingle: '{{firstName}} har nu 1 tillgänglig belöning.',
      newTotal: '{{firstName}} har nu {{count}} tillgängliga belöningar.',
      scanNext: 'Skanna nästa',
      done: 'Klar',
    },
  },
  stampCorrection: {
    title: 'Ta bort stämplar',
    sheetBackdropAccessibilityLabel: 'Stäng borttagning av stämplar',
    disclaimer: 'Den här åtgärden skapar en korrigeringspost. Den ursprungliga aktiviteten förblir oförändrad.',
    removeButton: 'Ta bort stämplar',
    reason: {
      label: 'Orsak till borttagning',
      placeholder: 'Välj en orsak',
    },
    note: 'Anteckning (valfri)',
    notePlaceholder: 'Lägg till en anteckning om borttagningen...',
    stepper: {
      label: 'Stämplar att ta bort',
      stampZero: '0 stämplar',
      stampSingle: '- 1 stämpel',
      stamps: '- {{count}} stämplar',
      decrementAccessibilityLabel: 'Ta bort färre stämplar',
      incrementAccessibilityLabel: 'Ta bort fler stämplar',
      countAccessibilityLabel: 'Tar bort {{count}} stämplar',
    },
    menu: {
      removeStamp: 'Ta bort stämpel',
      restoreReward: 'Återställ belöning',
      closeAccessibilityLabel: 'Stäng medlemsmeny',
    },
    success: {
      title: 'Stämplar borttagna',
      stampsSingle: '1 stämpel borttagen från {{fullName}}.',
      stamps: '{{count}} stämplar borttagna från {{fullName}}.',
      newTotalPrefix: '{{firstName}} har nu',
      newTotalSuffix: 'stämplar.',
      scanNext: 'Skanna nästa',
      done: 'Klar',
    },
    managerPin: {
      title: 'Chefs-PIN',
      subtitle: 'Ange chefs-PIN för att ta bort stämplar.',
      modalAccessibilityLabel: 'Chefs-PIN-auktorisering',
      closeAccessibilityLabel: 'Avbryt PIN-inmatning',
      codeProgressAccessibilityLabel: '{{entered}} av {{total}} siffror angivna',
      incorrectPin: 'Felaktig PIN. Försök igen.',
      removeError: 'Kunde inte ta bort stämplar. Försök igen.',
    },
  },
  stampAwarding: {
    sheetBackdropAccessibilityLabel: 'Stäng medlemsstämplingskortet',
    memberFound: 'Medlem hittad',
    memberMenuAccessibilityLabel: 'Medlemsalternativ',
    unknownMember: 'Okänd medlem',
    stampCountSingle: '1 stämpel',
    stampCount: '{{count}} stämplar',
    addStampsSingle: 'Lägg till 1 stämpel',
    addStamps: 'Lägg till {{count}} stämplar',
    addStampsAction: 'Lägg till stämplar',
    thisWillAdd: 'Det här lägger till',
    maxStampsCapped: 'Begränsat till maximalt {{max}} stämplar per transaktion.',
    loadError: 'Kunde inte ladda medlemsdata. Försök igen.',
    receiptReference: {
      label: 'Kvitto-/orderreferens',
      placeholder: 'Ange kvitto- eller orderreferens',
    },
    perMeal: {
      label: 'Antal stämplar',
      decrementAccessibilityLabel: 'Minska antal stämplar',
      incrementAccessibilityLabel: 'Öka antal stämplar',
      countAccessibilityLabel: '{{count}} stämplar valda',
    },
    spendBased: {
      label: 'Inköpsbelopp',
      placeholder: '0',
      currencyLabel: 'SEK',
      earningRule: 'Intjäningsregel: {{amount}} SEK = 1 stämpel',
      amountAccessibilityLabel: 'Inköpsbelopp i SEK',
    },
    stampPreview: {
      label: 'Stämpelförhandsvisning',
      current: 'Nuvarande: {{current}} / {{target}}',
      currentLabel: 'Innan',
      afterThis: 'Efter detta: {{after}} / {{target}}',
      afterThisLabel: 'Efter',
      rewardUnlocked: 'Gratis måltid upplåst',
      rewardsUnlockedCount: '{{count}} gratis måltider upplåsta',
      nextCardStarts: 'Nästa kort börjar på {{carry}} / {{target}}',
      nextCardStartsLabel: 'Nästa kort börjar på',
      stampFilledAccessibilityLabel: 'Stämpel intjänad',
      stampPreviewAccessibilityLabel: 'Stämpel att lägga till',
      stampEmptyAccessibilityLabel: 'Tom stämpelplats',
    },
    availableRewards: {
      title: 'Tillgängliga belöningar',
      redemptionNote: 'Belöningsinlösen kräver kund-QR.',
      rewardAccessibilityLabel: '{{name}} — belöning tillgänglig',
    },
    recentActivity: {
      title: 'Senaste aktivitet',
      activityType: {
        stamps_added:     'Stämplar tillagda',
        stamp_correction: 'Stämpelkorrigering',
        reward_unlocked:  'Belöning upplåst',
        reward_redeemed:  'Belöning inlöst',
        reward_restored:  'Belöning återställd',
        referral_bonus:   'Värvningsbonus',
        reward_expired:   'Belöning utgången',
      },
      stampSingle:  'stämpel',
      stamps:       'stämplar',
      rewardSingle: 'belöning',
      rewards:      'belöningar',
    },
    staffPin: {
      title: 'Kassör-PIN',
      subtitle: 'Ange kassör-PIN för att lägga till stämplar',
      modalAccessibilityLabel: 'Kassör-PIN-godkännande',
      closeAccessibilityLabel: 'Avbryt PIN-inmatning',
      codeProgressAccessibilityLabel: '{{entered}} av {{total}} siffror angivna',
      incorrectPin: 'Fel PIN. Försök igen.',
      awardError: 'Kunde inte lägga till stämplar. Försök igen.',
    },
    success: {
      title: 'Stämplar tillagda',
      stampsSingle: '1 stämpel tillagd för {{fullName}}.',
      stamps: '{{count}} stämplar tillagda för {{fullName}}.',
      newTotalPrefix: '{{firstName}} har nu',
      newTotalSuffix: 'stämplar.',
      rewardUnlocked: '{{rewardName}} upplåst!',
      rewardsUnlocked: '{{count}}x {{rewardName}} upplåst!',
      scanNext: 'Skanna nästa',
      done: 'Klar',
    },
  },
  loyalty: {
    saveChanges: 'Spara ändringar',
    loadError: 'Det gick inte att läsa in lojalitetsprogrammets konfiguration.',
    saveConfirm: {
      title: 'Bekräfta ändringar',
      subtitle: 'Granska ändringarna nedan innan du sparar.',
      closeAccessibilityLabel: 'Stäng bekräftelse',
      confirm: 'Bekräfta',
      saving: 'Sparar...',
      saveError: 'Det gick inte att spara lojalitetskonfigurationen. Försök igen.',
      completionMilestone: 'Avslutningens milstolpe',
      completionRewardInfo: 'Påverkar bara framtida kortavslutningar. Redan utdelade belöningar ändras inte.',
      stampTargetDecreaseWarning_one: '{{count}} kund kommer att slutföra sitt kort automatiskt. Extra stämplar förs över.',
      stampTargetDecreaseWarning_other: '{{count}} kunder kommer att slutföra sitt kort automatiskt. Extra stämplar förs över.',
    },
    earningRule: {
      sectionTitle: 'Insamlingsregel',
      subtitle: 'Välj hur kunder tjänar stämplar.',
      perMeal: 'Per måltid',
      perMealDescription: 'Kunder tjänar 1 stämpel för varje berättigad måltid som köps.',
      spendBased: 'Köpbelopp',
      spendBasedDescription: 'Kunder tjänar stämplar baserat på hur mycket de spenderar.',
      amountPerStamp: 'Belopp för 1 stämpel',
      currency: 'SEK',
      exampleSingular: 'Exempel: {{amount}} SEK spenderade ger 1 stämpel.',
      example: 'Exempel: {{amount}} SEK spenderade ger {{stamps}} stämplar.',
      amountRequiredError: 'Ange ett belopp',
      amountIntegerError: 'Ange ett heltal',
      amountRangeError: 'Ange ett belopp mellan {{min}} och {{max}} SEK',
    },
    rewardItems: {
      sectionTitle: 'Belöningsobjekt',
      subtitle: 'Skapa och hantera belöningar som du kan tilldela milstolpar.',
      add: 'Lägg till belöning',
      addDescription: 'Skapa en ny belöning som dina kunder kan tjäna.',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      translationIncomplete: 'Översättning',
      loadError: 'Det gick inte att läsa in belöningar.',
      modal: {
        addTitle: 'Lägg till belöning',
        editTitle: 'Redigera belöning',
        closeAccessibilityLabel: 'Stäng belöning',
        uploadImage: 'Ladda upp bild',
        uploadImageHint: 'JPG eller PNG rekommenderas',
        changeImage: 'Byt bild',
        removeImage: 'Ta bort bild',
        contentLanguage: 'Innehållsspråk',
        langEnglish: 'Engelska',
        langSwedish: 'Svenska',
        langEnglishFull: 'English (English)',
        langSwedishFull: 'Swedish (Svenska)',
        translationsTitle: 'Översättningar',
        translationsStatus: '{{count}} av {{total}} slutförda',
        langIncomplete: '{{language}} ofullständig',
        nameLabel: 'Namn',
        descriptionLabel: 'Beskrivning',
        nameIncomplete: 'Lägg till ett {{language}} namn för att slutföra översättningen.',
        activeLabel: 'Aktiv',
        activeLockedHint: 'Denna belöning är tilldelad en milstolpe. Tilldela om den där innan du inaktiverar.',
        save: 'Spara',
        saving: 'Sparar...',
        saveError: 'Det gick inte att spara denna belöning. Försök igen.',
      },
    },
    cardSetup: {
      sectionTitle: 'Kortupplägg',
      subtitle: 'Ange hur många stämplar kunder behöver samla.',
      stampsPerCard: 'Stämplar per kort',
      description: 'Kunder behöver {{count}} stämplar för att slutföra kortet och få slutföringsbelöningen.',
    },
    iconPicker: {
      drinks: 'Drycker',
      food: 'Mat',
      sweets: 'Sötsaker & snacks',
      reward: 'Belöning',
    },
    milestones: {
      sectionTitle: 'Milstolpar',
      subtitle: 'Definiera belöningarna kunder får vid specifika stämpelpositioner.',
      stampPosition: 'Stämpelposition',
      rewardItem: 'Belöning',
      cardIcon: 'Kortikon',
      delete: 'Ta bort',
      stampLabel: 'Stämpel {{position}}',
      completion: 'Avslutning',
      addMilestone: 'Lägg till milstolpe',
      rewardItemAccessibilityLabel: 'Belöning för stämpel {{position}}',
      completionRewardAccessibilityLabel: 'Avslutningsbelöning',
      deleteAccessibilityLabel: 'Ta bort milstolpe vid stämpel {{position}}',
      rewardItemRequiredError: 'Välj en belöning',
      noRewardItems: 'Lägg till en belöning först',
      cardIconAccessibilityLabel: 'Kortikon för stämpel {{position}}',
      completionCardIconAccessibilityLabel: 'Avslutningens kortikon',
    },
    customerPreview: {
      sectionTitle: 'Kundförhandsgranskning',
      subtitle: 'Det här är vad kunderna kommer att se.',
      logoAccessibilityLabel: 'Chill Out-logotyp',
      cardAccessibilityLabel: 'Förhandsgranskning av stämpelkort, {{current}} av {{total}} stämplar insamlade',
      count: '{{current}} / {{total}} stämplar',
      subtitleRemaining: '{{remaining}} stämplar kvar till nästa belöning',
      subtitleComplete: 'Belöning upplåst!',
      layoutDisclaimer: 'Den här förhandsgranskningen är en ungefärlig uppskattning. Den exakta layouten kan variera något beroende på kundens telefonskärm.',
      previewProgress: 'Förhandsgranskningens framsteg',
      previewProgressDescription: 'Justera antalet insamlade stämplar som visas i förhandsgranskningen.',
      decrementAccessibilityLabel: 'Minska antal stämplar i förhandsgranskningen',
      incrementAccessibilityLabel: 'Öka antal stämplar i förhandsgranskningen',
    },
  },
  birthdayReward: {
    saveChanges: 'Spara ändringar',
    saving: 'Sparar...',
    loadError: 'Det gick inte att läsa in födelsedagsbelöningsprogrammet.',
    saveError: 'Det gick inte att spara födelsedagsbelöningsprogrammet. Försök igen.',
    enable: {
      sectionTitle: 'Aktivera födelsedagsbelöning',
      subtitle: 'Slå på eller av födelsedagsbelöningsprogrammet för framtida utfärdanden.',
      toggleAccessibilityLabel: 'Växla födelsedagsbelöningsprogram',
      enabled: 'Aktiverad',
      disabled: 'Inaktiverad',
      info: 'Om du inaktiverar programmet stoppas endast framtida belöningar. Belöningar som redan utfärdats till kunder påverkas inte.',
    },
    rewardItems: {
      sectionTitle: 'Belöningsobjekt',
      subtitle: 'Skapa och hantera belöningen kunder kan få under sin födelsedagsmånad.',
      add: 'Lägg till belöning',
      addDescription: 'Skapa en ny födelsedagsbelöning.',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      translationIncomplete: 'Översättning',
      loadError: 'Det gick inte att läsa in belöningar.',
      modal: {
        addTitle: 'Lägg till belöning',
        editTitle: 'Redigera belöning',
        closeAccessibilityLabel: 'Stäng belöning',
        uploadImage: 'Ladda upp bild',
        uploadImageHint: 'JPG eller PNG rekommenderas',
        changeImage: 'Byt bild',
        removeImage: 'Ta bort bild',
        contentLanguage: 'Innehållsspråk',
        langEnglish: 'Engelska',
        langSwedish: 'Svenska',
        translationsTitle: 'Översättningar',
        translationsStatus: '{{count}} av {{total}} slutförda',
        langIncomplete: '{{language}} ofullständig',
        nameLabel: 'Namn',
        descriptionLabel: 'Beskrivning',
        nameIncomplete: 'Lägg till ett {{language}} namn för att slutföra översättningen.',
        activeLabel: 'Aktiv',
        activeLockedHint: 'Denna belöning är vald som den aktiva födelsedagsbelöningen. Välj en annan innan du inaktiverar.',
        save: 'Spara',
        saving: 'Sparar...',
        saveError: 'Det gick inte att spara denna belöning. Försök igen.',
      },
    },
    activeItem: {
      sectionTitle: 'Välj aktiv belöning',
      subtitle: 'Välj vilket belöningsobjekt som delas ut just nu.',
      placeholder: 'Välj ett belöningsobjekt',
      noRewardItems: 'Lägg till ett belöningsobjekt först',
      requiredError: 'Välj ett belöningsobjekt',
    },
    howItWorks: {
      sectionTitle: 'Så här fungerar det',
      notification: {
        title: 'Födelsedagsavisering',
        body: 'Kunder får en avisering när deras födelsedagsbelöning blir tillgänglig.',
      },
      validMonth: {
        title: 'Giltig under födelsedagsmånaden',
        body: 'Belöningen är giltig från början till slutet av kundens födelsedagsmånad.',
      },
      oncePerYear: {
        title: 'Delas ut en gång per år',
        body: 'Belöningen delas ut automatiskt en gång, under kundens födelsedagsmånad, varje år.',
      },
      birthdaySaved: {
        title: 'Födelsedatum måste sparas',
        body: 'Kunder måste spara sitt födelsedatum för att vara berättigade. Det behöver inte göras innan födelsedagsmånaden börjar.',
      },
    },
  },
  auditLog: {
    export: 'Exportera CSV',
    exporting: 'Exporterar...',
    exportError: 'Det gick inte att exportera. Försök igen.',
    exportAccessibilityLabel: 'Exportera granskningslogg som CSV',
    filters: {
      label: 'Filtrera',
      clear: 'Rensa filter',
      action: 'Åtgärd',
      admin: 'Admin',
    },
    dateRange: {
      closeAccessibilityLabel: 'Stäng datumväljare',
      today: 'Idag',
      yesterday: 'Igår',
      last7Days: 'Senaste 7 dagarna',
      last30Days: 'Senaste 30 dagarna',
      last90Days: 'Senaste 90 dagarna',
    },
    eventGroups: {
      cashierMgmt: 'Kassörhantering',
      deviceMgmt: 'Enhetshantering',
      settings: 'Inställningar',
      loyalty: 'Lojalitet',
      gdpr: 'GDPR',
      adminAuth: 'Admininloggning',
    },
    eventTypes: {
      cashier_created: 'Kassör skapad',
      cashier_updated: 'Kassör uppdaterad',
      device_created: 'Enhet skapad',
      device_updated: 'Enhet uppdaterad',
      loyalty_created: 'Lojalitet skapad',
      loyalty_updated: 'Lojalitet uppdaterad',
      reward_item_created: 'Belöning skapad',
      reward_item_updated: 'Belöning uppdaterad',
      settings_updated: 'Inställningar uppdaterade',
      member_anonymised: 'Medlem anonymiserad',
      stamp_adjustment: 'Stämpeljustering',
      reward_adjustment: 'Belöningsjustering',
      admin_signed_in: 'Admin inloggad',
      admin_signed_out: 'Admin utloggad',
      password_reset_requested: 'Lösenordsåterställning begärd',
      password_changed: 'Lösenord ändrat',
      admin_sign_in_failed: 'Admininloggning misslyckad',
      birthday_reward_updated: 'Födelsedagsbelöning uppdaterad',
    },
    columns: {
      dateTime: 'Datum och tid',
      action: 'Åtgärd',
      target: 'Mål',
      details: 'Detaljer',
      actionBy: 'Utförd av',
    },
    emptyTitle: 'Inga granskningsposter',
    emptyDescription: 'Granskningsposter visas här när adminåtgärder registreras.',
    loadError: 'Kunde inte ladda granskningsloggen. Försök igen.',
    noResults: 'Inga poster matchar de valda filtren.',
    rowAccessibilityLabel: '{{action}} av {{admin}} kl. {{time}}',
    detail: {
      title: 'Granskningspost',
      closeAccessibilityLabel: 'Stäng granskningspost',
      done: 'Klar',
      timestampLabel: 'Tidpunkt',
      actionByLabel: 'Utförd av',
      actionLabel: 'Åtgärd',
      targetLabel: 'Mål',
      changesLabel: 'Ändringar',
      reasonLabel: 'Anledning',
      noteLabel: 'Anteckning',
      ipAddressLabel: 'IP-adress',
      userAgentLabel: 'User agent',
      beforeLabel: 'Före',
      afterLabel: 'Efter',
      noChanges: 'Inga ändringar registrerade',
    },
    csv: {
      filterDateRange: 'Datumintervall',
    },
  },
  recentActivity: {
    export: 'Exportera CSV',
    exporting: 'Exporterar...',
    exportError: 'Det gick inte att exportera. Försök igen.',
    exportAccessibilityLabel: 'Exportera senaste aktivitet som CSV',
    search: {
      label: 'Sök medlemmar',
      placeholder: 'Sök efter namn, ID eller e-post',
      accessibilityLabel: 'Sök senaste aktivitet efter medlem',
      clearAccessibilityLabel: 'Rensa sökning',
    },
    filters: {
      label: 'Filter',
      clear: 'Rensa filter',
      activityType: 'Aktivitetstyp',
      staff: 'Utförd av',
      memberStatus: 'Medlemsstatus',
      anonymised: 'Anonymiserad',
      active: 'Aktiv',
    },
    activityTypes: {
      new_member_joined: 'Ny medlem anslöt',
    },
    columns: {
      dateTime: 'Datum & tid',
      activity: 'Aktivitet',
      change: 'Ändring',
      member: 'Medlem',
      by: 'Av',
    },
    emptyTitle: 'Ingen aktivitet ännu',
    emptyDescription: 'Lojalitetsaktivitet visas här när medlemmar samlar stämplar och löser in belöningar.',
    loadError: 'Kunde inte ladda senaste aktivitet. Försök igen.',
    noResults: 'Ingen aktivitet matchar de valda filtren.',
    rowAccessibilityLabel: '{{activity}} för {{member}} kl. {{time}}',
    detail: {
      closeAccessibilityLabel: 'Stäng aktivitetsdetaljer',
      close: 'Stäng',
      memberLabel: 'Medlem',
      performedByLabel: 'Utförd av',
      changeSummaryLabel: 'Ändringssammanfattning',
      receiptLabel: 'Kvittoreferens',
      reasonLabel: 'Anledning',
      noteLabel: 'Anteckning',
      deviceLabel: 'Enhet',
      system: 'System',
      managerRole: 'Chef',
      adminRole: 'Admin',
      targetReductionLabel: 'Stämpelmål sänkt',
      targetReductionStampsPerCard: 'Stämplar per kort: {{targetBefore}} → {{targetAfter}}',
      targetReductionMemberStamps: 'Medlemmens stämplar: {{before}} → {{after}}',
    },
    csv: {
      filterDateRange: 'Datumintervall',
      timestamp: 'Tidsstämpel',
      activity: 'Aktivitet',
      delta: 'Ändring',
      member: 'Medlem',
      memberEmail: 'Medlems e-post',
      memberId: 'Medlems-ID',
      performedBy: 'Utförd av',
      device: 'Enhet',
      receipt: 'Kvittoreferens',
      reason: 'Anledning',
      note: 'Anteckning',
    },
  },
  settings: {
    saveChanges: 'Spara ändringar',
    programOptions: {
      title: 'Programalternativ',
      subtitle: 'Hantera inställningar som styr stämpelanvändning och kundtillväxt.',
    },
    maxStampsPerTransaction: {
      title: 'Maximalt antal stämplar per transaktion',
      description: 'Begränsa antalet stämplar som kan läggas till i en enda transaktion. Intervall: 1–999.',
      decrementAccessibilityLabel: 'Minska maximalt antal stämplar',
      incrementAccessibilityLabel: 'Öka maximalt antal stämplar',
    },
    receiptReference: {
      title: 'Kvitto-/orderreferens',
      description: 'Kräv en kvitto- eller orderreferens vid stämpeltillägg.',
      accessibilityLabel: 'Växla kvittoreferenskrav',
    },
    referralProgram: {
      title: 'Värvningsprogram',
      description: 'Tillåt medlemmar att värva vänner. Både värvaren och den inbjudna vännen får 1 stämpel var.',
      accessibilityLabel: 'Växla värvningsprogram',
    },
    cashierPermissions: {
      title: 'Kassörbehörigheter',
      subtitle: 'Styr vilka justeringsåtgärder kassörer kan utföra.',
    },
    cashierStampCorrection: {
      title: 'Stämpelkorrigering',
      description: 'Tillåt kassörer att ta bort stämplar med en chef-PIN.',
      accessibilityLabel: 'Växla kassörers stämpelkorrigering',
    },
    cashierRewardRestore: {
      title: 'Återställning av belöning',
      description: 'Tillåt kassörer att återställa felaktigt inlösta belöningar med en chef-PIN.',
      accessibilityLabel: 'Växla kassörers belöningsåterställning',
    },
    discardChanges: {
      title: 'Ignorera osparade ändringar?',
      body: 'Dina ändringar har inte sparats.',
      keepEditing: 'Fortsätt redigera',
      discard: 'Ignorera ändringar',
      closeAccessibilityLabel: 'Fortsätt redigera',
    },
    saveConfirm: {
      title: 'Spara ändringar?',
      subtitle: 'Granska dina ändringar innan du sparar.',
      confirm: 'Spara ändringar',
      saving: 'Sparar...',
      saveError: 'Det gick inte att spara inställningarna. Försök igen.',
      maxStampsPerTransaction: 'Max stämplar per transaktion',
      receiptReference: 'Kvitto-/orderreferens',
      referralProgram: 'Värvningsprogram',
      cashierStampCorrection: 'Kassörers stämpelkorrigering',
      cashierRewardRestore: 'Kassörers belöningsåterställning',
    },
  },
}

export default sv
